import React from "react";
import CustomButton from "../../../components/ui/button";
import FieldLabel from "../../../components/label";
import Header from "../../../components/header";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Dialog, DialogTitle } from "@mui/material";
import { BUTTON_PROCEED } from "../../../constants";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";

const AssessmentGuideline = ({
  classes: { formGroup },
  onClose,
  modal,
  modalKey = "open",
}) => {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.open}
    >
      <Header onClick={() => {}} title={""} isBackButtonVisible={false} />
      <DialogTitle id="simple-dialog-title">
        <Box display="flex" justifyContent="center">
          <SectionTitle
            hideBack={true}
            title={"Checklist"}
            onClickHandler={(event, reason) => onClose(event, reason, modalKey)}
          />
        </Box>
      </DialogTitle>

      <Box m={1}>
        <Box className={formGroup}>
          <FieldLabel label="Ensure that you are in a decent network zone and a well-lit area." />
        </Box>

        <Box layout="column" mt={2} mb={0}>
          <CustomButton
            type="button"
            size="medium"
            color="primary"
            title={BUTTON_PROCEED}
            clickHandler={(event, reason) => onClose(event, reason, modalKey)}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(AssessmentGuideline);
